import { SpinnerIcon } from '@acceso/design-system';
import clsx from 'clsx';
import React, { Suspense } from 'react';
import { Group, Panel } from 'react-resizable-panels';

import { TProgramBroadcast } from '@/features/broadcast-schedule/types';
import { BroadcastScheduleProvider } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitLogotipos/context/BroadcastScheduleProvider';
import { TSegment } from '@/features/segments/types';

import { useBroadcastScheduleProgram } from '../../context/BroadcastScheduleProgramContext';
import { useGlobalViewBootstrap } from '../../hooks/useGlobalViewBootstrap';
import { BroadcastScheduleProgramBodySegmentToolkit } from '../BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/BroadcastScheduleProgramBodySegmentToolkit';

import { BroadcastScheduleProgramGlobalViewBodyProgramCard } from './components/BroadcastScheduleProgramGlobalViewBodyProgramCard/BroadcastScheduleProgramGlobalViewBodyProgramCard';

type TBroadcastScheduleProgramGlobalViewBodyProps = {
  programBroadcast?: TProgramBroadcast;
  allSegments: TSegment[];
  isLoading?: boolean;
};

export default function BroadcastScheduleProgramGlobalViewBody({
  programBroadcast,
  allSegments,
}: TBroadcastScheduleProgramGlobalViewBodyProps) {
  const { isHeaderVisible, pinnedId, toolkitComponents, toolkitCardRegionRef } =
    useBroadcastScheduleProgram();

  useGlobalViewBootstrap({ allSegments });

  return (
    <BroadcastScheduleProvider>
      <Group
        className={clsx(
          'flex flex-col gap-2 lg:flex-row',
          isHeaderVisible ? 'lg:max-h-[calc(100vh-170px)]' : 'lg:max-h-[calc(100vh-120px)]'
        )}
      >
        <Panel minSize={300} maxSize="75%">
          <BroadcastScheduleProgramGlobalViewBodyProgramCard
            programBroadcast={programBroadcast}
            segments={allSegments}
          />
        </Panel>

        {pinnedId && toolkitComponents[pinnedId] && (
          <Suspense fallback={<SpinnerIcon className="animation infinite" />}>
            <Panel minSize={300}>
              <div
                ref={toolkitCardRegionRef}
                className={clsx('z-20 order-3 w-full flex-auto overflow-auto lg:order-2')}
                id="parrilla-global-view-toolkit-detail"
              >
                {React.createElement(toolkitComponents[pinnedId], { programBroadcast })}
              </div>
            </Panel>
          </Suspense>
        )}

        <div className="mt-1">
          <BroadcastScheduleProgramBodySegmentToolkit />
        </div>
      </Group>
    </BroadcastScheduleProvider>
  );
}
